import React, { createContext, useState, useContext } from "react";
import { GetCartCount } from "../api/cartService";
import { GetEnquiryCount } from "../api/enquiryService";

const CountContext = createContext();

export const useCount = () => useContext(CountContext);

export const CountProvider = ({ children }) => {
    const [cartCount, setCartCount] = useState(0);
    const [enquiryCount, setEnquiryCount] = useState(0);

    const fetchCartCount = async () => {
        try {
            const res = await GetCartCount();
            const cnt = res?.CartCount?.[0]?.CartCount ?? 0;
            setCartCount(Number(cnt));
        } catch (err) {
            console.error("fetchCartCount error:", err);
            setCartCount(0);
        }
    };

    const fetchEnquiryCount = async () => {
        try {
            const res = await GetEnquiryCount();
            const cnt = res?.EnquiryCount?.[0]?.EnquiryCount ?? 0;
            setEnquiryCount(Number(cnt));
        } catch (err) {
            console.error("fetchEnquiryCount error:", err);
            setEnquiryCount(0);
        }
    };

    return (
        <CountContext.Provider
            value={{
                cartCount,
                setCartCount,     
                fetchCartCount,
                enquiryCount,
                setEnquiryCount,
                fetchEnquiryCount,
            }}
        >
            {children}
        </CountContext.Provider>
    );
};

export default CountContext;
